import { render } from "./PathfinderPillarCard.vue?vue&type=template&id=ace91260&scoped=true"
import script from "./PathfinderPillarCard.vue?vue&type=script&lang=js"
export * from "./PathfinderPillarCard.vue?vue&type=script&lang=js"

import "./PathfinderPillarCard.vue?vue&type=style&index=0&id=ace91260&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ace91260"]])

export default __exports__